import { render, staticRenderFns } from "./StaffGroupProfile.vue?vue&type=template&id=6a36aa7e&scoped=true"
import script from "./StaffGroupProfile.vue?vue&type=script&lang=js"
export * from "./StaffGroupProfile.vue?vue&type=script&lang=js"
import style0 from "./StaffGroupProfile.vue?vue&type=style&index=0&id=6a36aa7e&prod&scoped=true&lang=css"
import style1 from "./StaffGroupProfile.vue?vue&type=style&index=1&id=6a36aa7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a36aa7e",
  null
  
)

export default component.exports